var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['process-content', 'process-editor', _vm.$route.query.menuType == 'researcher' ? _vm.editorLayoutClass : 'layout_type_4']
  }, [_c('ProcessTop', {
    attrs: {
      "readOnly": true,
      "experimentFlag": true
    }
  }), _c('div', {
    ref: "topPanel",
    staticClass: "topPanel"
  }, [_c('IssueList', {
    attrs: {
      "experimentFlag": true
    }
  }), _c('ReadOnlyEditor'), _c('SideBar'), _c('ProcessReadOnlyBtmOption', {
    attrs: {
      "processType": _vm.processType,
      "experimentFlag": true
    }
  }), _c('ProcessReadOnlyDocumentOption', {
    attrs: {
      "apiType": `process`
    }
  })], 1), _c('div', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable",
      value: {
        target: 'topPanel'
      },
      expression: "{ target: 'topPanel' }"
    }],
    staticClass: "divider"
  }, [_c('div', {
    staticClass: "divider_btn"
  })]), _c('ExperimentResult', {
    attrs: {
      "editKey": _vm.editKey,
      "mode": _vm.mode
    },
    on: {
      "editExperiment": _vm.editExperiment
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }